/**
 * Helper to get history router from instantsearch.js
 * In old app, rollup alias replaces this with a mock that returns null
 * In new app, it loads the real router
 */

export default function getHistoryRouter() {
  try {
    // This will be aliased to mock in rollup build for old app compatibility
    // eslint-disable-next-line import/no-unresolved, global-require
    const routers = require('instantsearch.js/es/lib/routers');
    return routers.history;
  } catch (e) {
    // Module not available
    return null;
  }
}
